import $ from 'jquery';
import lottie from 'lottie-web';

import json from './transition.json';
import bubblejson from './bubble.json';

const playTransition = () => {
  var bubble = lottie.loadAnimation({
    container: $('.bubble')[0],
    renderer: 'svg',
    loop: false,
    autoplay: true,
    animationData: json
  });

  $('.preloader').addClass('header');
  $('.preloader .star, .preloader .hanger').remove();

  bubble.addEventListener('complete', function(){

    var newBubble = $('<div class="bubbleloop"></div>');
    newBubble.hide();
    $('.bubble').after(newBubble);
    $('.bubble').remove();
    newBubble.show();

    lottie.loadAnimation({
      container: newBubble[0],
      renderer: 'svg',
      loop: true,
      autoplay: true,
      animationData: bubblejson
    }).play();
  });
};

export default playTransition;
